import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { GridColDef, GridPinnedColumnFields } from '@mui/x-data-grid-pro';

export type PersistedWorklistColumn = Pick<
  GridColDef,
  | 'field'
  | 'headerName'
  | 'width'
  | 'minWidth'
  | 'flex'
  | 'sortable'
  | 'filterable'
  | 'disableColumnMenu'
  | 'align'
  | 'headerAlign'
>;

export const initialWorklistColumns: PersistedWorklistColumn[] = [
  {
    field: 'task',
    headerName: 'Task',
    minWidth: 220,
    flex: 1,
    sortable: true,
    filterable: false,
  },
  {
    field: 'category',
    headerName: 'Category',
    minWidth: 150,
    flex: 1,
    sortable: true,
    filterable: false,
  },
  {
    field: 'patient',
    headerName: 'Patient',
    minWidth: 180,
    flex: 1,
    sortable: true,
    filterable: false,
  },
  {
    field: 'priority',
    headerName: 'Priority',
    width: 130,
    minWidth: 130,
    sortable: true,
    filterable: false,
  },
  {
    field: 'due_date',
    headerName: 'Due date',
    width: 130,
    minWidth: 130,
    sortable: true,
    filterable: false,
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 150,
    minWidth: 150,
    sortable: true,
    filterable: false,
  },
  {
    field: 'created_date',
    headerName: 'Created date',
    width: 140,
    minWidth: 140,
    sortable: true,
    filterable: false,
  },
  {
    field: 'last_updated_at',
    headerName: 'Last updated',
    width: 150,
    minWidth: 150,
    sortable: true,
    filterable: false,
  },
  {
    field: 'provider',
    headerName: 'Provider',
    minWidth: 170,
    flex: 1,
    sortable: true,
    filterable: false,
  },
  {
    field: 'location',
    headerName: 'Location',
    minWidth: 170,
    flex: 1,
    sortable: true,
    filterable: false,
  },
  {
    field: 'assignment',
    headerName: 'Assignment',
    minWidth: 190,
    flex: 1,
    sortable: true,
    filterable: false,
  },
];

export const initialWorklistPinnedColumns: GridPinnedColumnFields = {
  left: [],
  right: [],
};

interface IWorklistTableStore {
  columns: PersistedWorklistColumn[];
  setColumns: (columns: PersistedWorklistColumn[]) => void;
  pinnedColumns: GridPinnedColumnFields;
  setPinnedColumns: (pinnedColumns: GridPinnedColumnFields) => void;
  resetView: () => void;
}

export const useWorklistTableStore = create<IWorklistTableStore>()(
  persist(
    set => ({
      columns: initialWorklistColumns,
      setColumns: columns => set({ columns }),
      pinnedColumns: initialWorklistPinnedColumns,
      setPinnedColumns: pinnedColumns => set({ pinnedColumns }),
      resetView: () =>
        set({
          columns: initialWorklistColumns,
          pinnedColumns: initialWorklistPinnedColumns,
        }),
    }),
    {
      name: 'worklist-table-store',
    },
  ),
);
